import { useEffect, useState } from "react";
import { upsertTag, uuidMapping } from "../helper";

export const useRoleFilter = (talentFilter, talentFilterTags, rolesList) => {
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedRoleNames, setSelectedRoleNames] = useState([]);

  useEffect(() => {
    if (!talentFilter?.event_roles?.list) return;

    setSelectedRoles(talentFilter.event_roles.list);
  }, []);

  useEffect(() => {
    if (!talentFilter || Object.keys(talentFilter).length === 0) {
      setSelectedRoles([]);
    }
  }, [talentFilter]);

  useEffect(() => {
    if (!rolesList?.length) return;

    const allOptions = rolesList.flatMap(r => r.options || []);

    const names = allOptions
      .filter(option => selectedRoles.includes(option.value))
      .map(option => option.label);

    setSelectedRoleNames(names);
  }, [selectedRoles, rolesList]);

  const buildRoleFilter = () => {
    if (!selectedRoles.length) return null;

    const finalRoles = {
      has_all_in_list: true,
      list: selectedRoles,
    };

    const tags = upsertTag(
      talentFilterTags,
      uuidMapping.roles,
      selectedRoleNames
    );

    return { rolesPayload: finalRoles, tags };
  };

  return {
    selectedRoles,
    setSelectedRoles,
    buildRoleFilter,
  };
};
